import type { SVGProps } from "react";

export const DownloadIcon2 = ({
  width = "17",
  height = "18",
  props,
}: {
  width?: string;
  height?: string;
  props?: SVGProps<SVGSVGElement>;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 0.9375C12.9528 0.9375 16.5625 4.5472 16.5625 9C16.5625 13.4528 12.9528 17.0625 8.5 17.0625C4.0472 17.0625 0.4375 13.4528 0.4375 9C0.4375 4.5472 4.0472 0.9375 8.5 0.9375ZM8.5 2.0625C4.66852 2.0625 1.5625 5.16852 1.5625 9C1.5625 12.8315 4.66852 15.9375 8.5 15.9375C12.3315 15.9375 15.4375 12.8315 15.4375 9C15.4375 5.16852 12.3315 2.0625 8.5 2.0625ZM10.7412 11.4375C11.0519 11.4375 11.3037 11.6893 11.3037 12C11.3037 12.3107 11.0519 12.5625 10.7412 12.5625H6.24121C5.93055 12.5625 5.67871 12.3107 5.67871 12C5.67871 11.6893 5.93055 11.4375 6.24121 11.4375H10.7412ZM8.5 4.6875C8.81066 4.6875 9.0625 4.93934 9.0625 5.25V8.3916L9.60254 7.85254C9.82221 7.63287 10.1778 7.63287 10.3975 7.85254C10.6171 8.07221 10.6171 8.42779 10.3975 8.64746L9.42773 9.61719C9.42174 9.62318 9.41621 9.62969 9.41016 9.63574C9.30149 9.7445 9.18386 9.86232 9.07129 9.94824C8.93934 10.0489 8.7501 10.1572 8.5 10.1572C8.2499 10.1572 8.06066 10.0489 7.92871 9.94824C7.81614 9.86232 7.69851 9.7445 7.58984 9.63574C7.5838 9.62969 7.57826 9.62318 7.57227 9.61719L6.60254 8.64746C6.38287 8.42779 6.38287 8.07221 6.60254 7.85254C6.82221 7.63287 7.17779 7.63287 7.39746 7.85254L7.9375 8.3916V5.25C7.9375 4.93934 8.18934 4.6875 8.5 4.6875Z"
      fill="currentColor"
    />
  </svg>
);
